export default {
  currentUserInfo: {},
  passwordHasChanged: false,
  riskInfo: {},
};
